import type * as Types from 'app/types/graphql';

export type VariantTemplateSelectFragment = Pick<
  Types.VariantTemplate,
  | 'createdAt'
  | 'deletedAt'
  | 'id'
  | 'redirectURL'
  | 'themeID'
  | 'updatedAt'
  | 'thumbnailURL'
  | 'title'
>;

export const VariantTemplateSelectFragmentDoc = `
    fragment VariantTemplateSelect on VariantTemplate {
  createdAt
  deletedAt
  id
  redirectURL
  themeID
  updatedAt
  thumbnailURL
  title
}
    `;
